// extracted by mini-css-extract-plugin
export default {"breadCrumbs":"Breadcrumbs_breadCrumbs__p3T5v"};